import { render, staticRenderFns } from "./MembersPapers.vue?vue&type=template&id=9cc40124&scoped=true"
import script from "./MembersPapers.vue?vue&type=script&lang=js"
export * from "./MembersPapers.vue?vue&type=script&lang=js"
import style0 from "./MembersPapers.vue?vue&type=style&index=0&id=9cc40124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc40124",
  null
  
)

export default component.exports